import { connect } from 'react-redux';
import { withTranslation } from '@piwikpro/ui-components';
import GlobalPrivacySettings from './GlobalPrivacySettings';

const mapStateToProps = (state: any) => ({
  settings: state.trackerSettings.global.settings,
  isLoading: state.trackerSettings.global.isLoading,
  failed: state.trackerSettings.global.failed,
});

export const ConnectedGlobalPrivacySettings = connect(
  mapStateToProps, null,
)(GlobalPrivacySettings);

export default withTranslation(['administration'])(ConnectedGlobalPrivacySettings as any);
